import { FirestoreService } from './../shared/services/firestore/firestore.service';
import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { TableData } from '../md/md-table/md-table.component';
import swal from 'sweetalert2';
import { Sort } from '@angular/material/sort';
import * as firebase from 'firebase';
import { SaludService } from '../shared/services/apiSalud/salud.service';
import { Mail } from '../shared/interfaces/mail.interface';

// declare let Email: any;
declare let emailjs: any;
declare const $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, AfterViewInit {
  config: any;
  public tableData1: TableData;
  public consultations = [];
  public professionals = [];
  sortedData;

  constructor(
    private firestoreService: FirestoreService,
    private saludService: SaludService
    ) { }

  ngOnInit() {

    this.tableData1 = {
      headerRow: ['Fecha', 'Tipo de consulta', 'Nombre', 'RUT', 'Telefono', 'Mail', 'Prestación', 'Profesional', 'Fecha Cita', 'Hora Cita', 'Conexión internet', 'Link', 'Estado', 'Acciones'],
      dataRows: this.sortedData
    };

    this.firestoreService.getConsultations().subscribe((consultationsSnapshot) => {
      this.consultations = [];
      let list = [];
      consultationsSnapshot.forEach((conData: any) => {

        if(conData.payload.doc.data().status == "Pendiente") {
          list.push({
            id: conData.payload.doc.id,
            data: conData.payload.doc.data()
          });
        }
      })
      // this.consultations = list.sort((a, b) => {
      //   return <any>new Date(b.data.creationDate) - <any>new Date(a.data.creationDate)
      // })
      this.consultations = list.sort((a, b) => {
        if (a.data.status === "Pendiente") {
          return -1;
        } else {
          return 0;
        }
      })

      this.sortedData = this.consultations.slice();
    });

    this.firestoreService.getProfessionals().subscribe((pSnapshot) => {
      this.professionals = [];
      let list = [];
      pSnapshot.forEach((conData: any) => {
        list.push({
          id: conData.payload.doc.id,
          data: conData.payload.doc.data()
        });
      })
      this.professionals = list;
    });

    this.config = {
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: this.consultations.length
    };

  }

  sortData(sort: Sort) {
    console.log('sort', sort);
    const data = this.consultations.slice();
    console.log('data', data);
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'creationDate': return compare(a.creationDate, b.creationDate, isAsc);
        case 'status': return a.data.status === "Pendiente" ? -1 : 0
        default: return 0;
      }
    });
  }

  ngAfterViewInit() {

  }

  pageChanged(event) {
    this.config.currentPage = event;
  }

  changeStatus(row: any, status: string) {

    if (status === 'done') {
      swal({
        title: 'Cambiar estado a: Resuelto?',
        // text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {

          if (!row.data.professional || row.data.professional === null) {
            this.showError("Debe colocar un profesional para cambiar el estado.");
            return;
          }
          if (!row.data.professional || row.data.professional === null) {
            this.showError("Debe colocar un profesional para cambiar el estado.");
            return;
          }
          if (!row.data.appointmentDate || row.data.appointmentDate === null) {
            this.showError("Debe colocar una fecha de cita para cambiar el estado.");
            return;
          }
          if (!row.data.appointmentTime || row.data.appointmentTime === null) {
            this.showError("Debe colocar una hora de cita para cambiar el estado.");
            return;
          }
          row.data.status = "Resuelto";
          this.firestoreService.updateConsultation(row.id, row.data).then(() => {
            swal(
              {
                title: 'Confirmado!',
                text: 'Se enviará un mail al paciente y al profesional',
                type: 'success',
                confirmButtonClass: "btn btn-success",
                buttonsStyling: false
              }
            ).then(() => {
              this.sendMail(row.data);
            })
          }, (error) => {
            // this.showError(error);
          })
        }
      })
    } else {
      swal({
        title: 'Cambiar estado a: Cancelado?',
        // text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          row.data.status = "Cancelado";
          this.firestoreService.updateConsultation(row.id, row.data).then(() => {
            swal(
              {
                title: 'Confirmado!',
                text: 'Ha cambiado el estado con éxito',
                type: 'success',
                confirmButtonClass: "btn btn-success",
                buttonsStyling: false
              }
            ).then(({value}) => {
              // console.log(value)
              this.sendMailCancelar(row.data, value)
            })
          }, (error) => {
            // this.showError(error);            
          })
        }
      })
    }

  }

  showError(msg) {
    $.notify({
      message: msg
    }, {
      type: 'danger',
      timer: 3000,
      placement: {
        from: 'top',
        align: 'right'
      }
    });
  }

  sendMail(data) {
    var ActualUser = firebase.auth().currentUser;
    var emailAU: string;
    if(ActualUser != null){
      emailAU = ActualUser.email;
    }
    let text = `
                  Estimado/a, <br />
                  Su cita ha sido confirmada. <br />
                  Recuerde conectarse o presentarse 10 minutos <br />
                  antes de la fecha y hora dada.
                  Fecha: <b>${data.appointmentDate}</b> <br />
                  Hora: <b>${data.appointmentTime}</b> <br />
                  Paciente: <b>${data.name}</b> <br />
                  Prestación: <b>${data.lendingName}</b> <br />
                  Profesional: <b>${data.professional.name}</b> <br />      
                  `
    if (data.consultationType == 'Virtual') {
      text += `Link: <a href="${data.link}"><b>${data.link}</b></a> <br />
                  Si no puede ingresar al link, favor copiar <br/>
                  y pegar en el navegador web.<br/>`
    }
    const subject = '[Cita Confirmada] Rosario';
    const to = `${data.mail}, ${data.professional.mail},${emailAU}`;
    const content: Mail = {
      to: to,
      subject: subject,
      body: text
    }
    this.saludService.sendMail(content)
      .toPromise()
      .then(message => {
        console.log(message);
      }, (error) => {
        console.log(error);
      });
  }
  sendMailCancelar(data, msg){
    var ActualUser = firebase.auth().currentUser;
    var emailAU: string;
    if(ActualUser != null){
      emailAU = ActualUser.email;
    }
    let text = `
                  Estimado/a, <br />
                  Su cita ha sido cancelada. <br />
                  Por el siguiente motivo: <b>${msg}</b> <br />    
                  `
    const subject = '[Cita Cancelada] CESFAM Rosario';
    const to = `${data.mail},${emailAU}`;
    const content: Mail = {
      to: to,
      subject: subject,
      body: text
    }
    this.saludService.sendMail(content)
      .toPromise()
      .then(message => {
        console.log(message);
      }, (error) => {
        console.log(error);
      });
  }
}



function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}